import React from 'react'
import { GoogleMap, Marker, Polygon } from '@react-google-maps/api'
import { Button } from '../button/Button'
import classes from './ZoneMapEditor.module.sass'
import { useZoneMapEditor } from './useZoneMapEditor'

type PolygonPoint = { lat: number; lng: number }

type OtherZone = {
  clusterDeliveryId: number
  polygon: PolygonPoint[]
}

type Props = {
  center: { lat: number; lng: number }
  initialPolygon?: PolygonPoint[]
  otherZones?: OtherZone[]
  onSave: (polygon: PolygonPoint[]) => void
  onClose: () => void
  height?: number
  zoom?: number
}

const containerStyle = { width: '100%', height: '100%' }

export const ZoneMapEditor: React.FC<Props> = ({
  center,
  initialPolygon,
  otherZones = [],
  onSave,
  onClose,
  height = 700,
  zoom = 13,
}) => {
  const { isLoaded, ready, hasPolygon, onMapLoad, handleClear, handleSave } = useZoneMapEditor({
    center,
    initialPolygon,
    onSave,
    zoom,
  })

  const safeCenter = {
    lat: Number(center.lat),
    lng: Number(center.lng),
  }

  if (!isLoaded) return <div className={classes.loading}>Загрузка карты...</div>

  return (
    <div className={classes.container} style={{ height }}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={safeCenter}
        zoom={zoom}
        onLoad={onMapLoad}
        options={{
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        }}
      >
        {/* ❌ Неактивные зоны этой же точки — серые, не кликабельные */}
        {otherZones.map((z) => (
          <Polygon
            key={z.clusterDeliveryId}
            paths={z.polygon.map((p) => ({ lat: Number(p.lat), lng: Number(p.lng) }))}
            options={{
              fillColor: '#999999',
              fillOpacity: 0.1,
              strokeColor: '#999999',
              strokeOpacity: 0.5,
              strokeWeight: 1,
              clickable: false,
              zIndex: 1,
            }}
          />
        ))}

        <Marker position={safeCenter} />
      </GoogleMap>

      <div className={classes.actions}>
        <Button text="Очистить" onClick={handleClear} small />
        <Button text="Отмена" onClick={onClose} small />
        <Button text="Сохранить" onClick={handleSave} disabled={!ready || !hasPolygon} small />
      </div>
    </div>
  )
}
